import { ComboBox } from "../../../components/common/utils/combobox";
import { PolizaEntity } from "./polizas_cliente_entity";

export class PolizaVAM {
    constructor(
        public FechaDesde?: Date,
        public FechaHasta?: Date,
        public TopRegistros?: number,
        public TipoFecha?: number,
        public Poliza?: PolizaEntity,
        public Ramos?: number[],
        public CodTitular?: number,
    ) { }
}

export class BusquedaSiniestralidad {
    constructor(
        public CodigoGrupo?: number,
        public CodigoCiudad?: number,
        public CodigoCliente?: number,
        public CodigoUnidad?: number,
        public CodigoRamo?: string,
        public CodigoPlan?: number,
        public FechaDesde?: Date,
        public FechaHasta?: Date,
        public CodigoTitular?: number,
        public TipoFecha?: number,
        public TopRegistros?: number,
        public CodigoTipoNegocio?: number
    ) { }
}
export class ConsultaSiniestralidad {
    constructor(
        public Resumen?: ResumenSiniestralidad,
        public Clientes?: SiniestralidadClientes,
        public RankingTitulares?: RankingTitulares,
        public Maternidad?: SiniestralidadMaternidad,
        public ProveedorXValor?: ProveedoresSiniestralidad,
        public ProveedorXReclamo?: ProveedoresSiniestralidad,
        public DiagnosticoXReclamo?: RankingDiagnosticos,
        public DetalleDiagnostico?: DetalleDiagnostico
    ) { }
}

export class ResumenSiniestralidad {
    constructor(
        public Mensual?: SiniestralidadMensual[],
        public Acumulada?: SiniestralidadMensual,
        public TipoPaciente?: SiniestralidadPorTipo[],
        public TipoAtencion?: SiniestralidadPorTipo[],
        public DetalleTipoAtencion?: SiniestralidadPorTipo[],
        public UsoPoliza?: SiniestralidadPoliza
    ) { }
}
export class SiniestralidadMensual {
    constructor(
        public NombreCliente?: string,
        public NombrePlan?: string,
        public Mes?: string,
        public ValorReembolsado?: number,
        public NumeroReclamos?: number,
        public PrimaRecaudada?: number,
        public Siniestralidad?: number,
        public Anio?: number
    ) { }
}
export class SiniestralidadPorTipo {
    constructor(
        public NombreTipo?: string,
        public NombreCliente?: string,
        public NombrePlan?: string,
        public ValorReembolsado?: number,
        public PorcentajeReembolsado?: number,
        public PromedioReclamo?: number,
        public ValorPresentado?: number,
        public ValorDeducible?: number,
        public ValorCopago?: number,
        public NumeroReclamos?: number
    ) { }
}
export class SiniestralidadPoliza {
    constructor(
        public NombrePlan?: string,
        public TitularesAsegurados?: number,
        public TitularesSiniestros?: number,
        public PorcentajeUso?: number
    ) { }
}
export class SiniestralidadClientes {
    constructor(
        public Mensual?: SiniestralidadPlan[],
        public TipoPaciente?: SiniestralidadPlan[],
        public TipoAtencion?: SiniestralidadPlan[],
        public UsoPoliza?: SiniestralidadPlan[]
    ) { }
}
export class SiniestralidadPlan {
    constructor(
        public NombreCliente?: string,
        public CodigoCliente?: number,
        public Mensual?: SiniestralidadMensual[],
        public TipoPaciente?: SiniestralidadTipoPaciente[],
        public TipoAtencion?: SiniestralidadTipoAtencion[],
        public DetalleTipoAtencion?: SiniestralidadTipoAtencion[],
        public UsoPoliza?: SiniestralidadPoliza[]
    ) { }
}
export class SiniestralidadTipoPaciente {
    constructor(
        public Titulares?: SiniestralidadPorTipo,
        public Dependientes?: SiniestralidadPorTipo,
        public Total?: SiniestralidadPorTipo
    ) { }
}
export class SiniestralidadTipoAtencion {
    constructor(
        public NombrePlan?: string,
        public TipoAtencion?: SiniestralidadPorTipo
    ) { }
}
export class RankingTitulares {
    constructor(
        public TitularesMayorValor?: DetalleRankingTitulares[],
        public DetalleTitularesMayorValor?: DetalleRankingTitulares[],
        public TitularesMayorNumeroReclamos?: DetalleRankingTitulares[],
        public DetalleTitularesMayorNumeroReclamos?: DetalleRankingTitulares[]
    ) { }
}
export class DetalleRankingTitulares {
    constructor(
        public CodigoTitular?: number,
        public ApellidoNombresTitular?: string,
        public ValorReembolsado?: number,
        public NumeroReclamos?: number,
        public InfoDependientes?: InformacionDependiente[],
        public NombreDiagnostico?: string,
        public NumeroRegistro?: number,
        public NombreBeneficiario?: string,
        public Relacion?: string,
        public TotalValorReembolsado?: number,
        public TotalNumeroReclamos?: number
    ) { }
}
export class InformacionDependiente {
    constructor(
        public CodigoDependiente?: number,
        public NombreDependiente?: string,
        public Relacion?: string
    ) { }
}
export class SiniestralidadMaternidad {
    constructor(
        public Maternidades?: MaternidadEntity[],
        public NumTitularesMaternidad?: number,
        public NumDepenMaternidad?: number,
        public TotalMaternidades?: number
    ) { }
}
export class MaternidadEntity {
    constructor(
        public CodigoTitular?: number,
        public NombresTitular?: string,
        public TipoPaciente?: number,
        public TipoAsegurado?: string,
        public Beneficiario?: string,
        public NumeroReclamos?: number,
        public ValorReembolsado?: number
    ) { }
}
export class ProveedoresSiniestralidad {
    constructor(
        public SubTotalNumeroReclamo?: number,
        public SubTotalValorReembolsado?: number,
        public SubTotalPorcentajeReembolzado?: number,
        public DetallesProveedores?: DetalleProveedoresSiniestralidad[]
    ) { }
}
export class DetalleProveedoresSiniestralidad {
    constructor(
        public NombreProveedor?: string,
        public NumeroReclamos?: number,
        public ValorReembolsado?: number,
        public PorcentajeReembolsado?: number
    ) { }
}
export class RankingDiagnosticos {
    constructor(
        public DiagnosticosXReclamos?: SiniestralidadDiagnostico[],
        public DetalleDiagnosticosXReclamos?: DetalleDiagnosticoSiniestralidad,
        public DiagnosticosMayorValor?: SiniestralidadDiagnostico[],
        public DetalleDiagnosticosMayorValor?: DetalleDiagnosticoSiniestralidad
    ) { }
}
export class SiniestralidadDiagnostico {
    constructor(
        public CodigoTitular?: number,
        public ValorReembolsado?: number,
        public NumeroReclamos?: number,
        public NombreDiagnostico?: string,
        public NumeroRegistro?: number,
        public PorcenjateReembolso?: number,
        public ReclamosTitular?: number,
        public ReclamosDependiente?: number,
        public ReembolsoTitular?: number,
        public ReembolsoDependiente?: number
    ) { }
}
export class DetalleDiagnosticoSiniestralidad {
    constructor(
        public TipoPaciente?: SiniestralidadDiagnostico[],
        public TipoDependiente?: SiniestralidadDependientes[]
    ) { }
}
export class SiniestralidadDependientes {
    constructor(
        public NombreParentezco?: string,
        public Dependientes?: SiniestralidadDiagnostico[]
    ) { }
}
export class DetalleDiagnostico {
    constructor(
        public DiagnosticoMayorValor?: SiniestralidadDiagnostico[]
    ) { }
}

export class MovimientosVamEntity {
    constructor(
        public Anio?: number,
        public CodigoCiudad?: number,
        public CodigoCliente?: number,
        public Ramo?: string,
        public CodigoUnidad?: number,
        public Mes?: number,
        public CodigoPlan?: number,
        public Poliza?: string,
        public FechiInicio?: string,
        public FechiFin?: string,
    ) { }
}
export class ResultadoMovmientosPorPlan {
    constructor(
        public NombreCliente?: string,
        public NombrePlan?: string,
        public PrimaInclusiones?: number,
        public PrimaExclusiones?: number,
        public PrimaSinMov?: number,
        public PrimaTotal?: number,
        public Inclusiones?: number,
        public SinMovimientos?: number,
        public Exclusiones?: number,
        public NombreCategoria?: string,
    ) { }
}

export class PlanVam {
    constructor(
        public Nombre?: string,
        public CodigoPlan?: number,
        public CodigoPlanCliente?: number
    ) { }
}

export class InclusionEntity {
    constructor(
        public NombresApellidosTitular?: string,
        public NombresPersonaIncluir?: string,
        public ApellidosPersonaIncluir?: string,
        public Identificacion?: string,
        public FechaNacimiento?: Date,
        public FechaInclusion?: Date,
        public CodigoSexo?: number,
        public Email?: string,
        public Genero?: string,
        public Poliza?: string,
        public CodigoCiudad?: number,
        public CodigoCliente?: number,
        public CodigoPlan?: number,
        public EsDependiente?: boolean,
        public Relacion?: string,
        public CodigoRel?: number,
        public NombrePlan?: string,
        public CodigoUsuario?: number,
        public CodigoPolCmb?: number,
        public CodigoPlanCmb?: number,
        public CodigoTitular?: number,
        public CedulaTitular?: string
        
    ) { }
}



export class ExclusionEntity {
    constructor(
        public CodigoBeneficiario?: number,
        public CodigoUsuario?: number,
        public BanderaDependiente?: boolean,
        public NombresApellidos?: string,
        public Identificacion?: string,
        public CodigoTitular?: number
    ) { }
}

export class ExclusionVam {
    constructor(
        public CodigoCliente?: number,
        public CodigoCiudad?: number,
        public ListaExclusiones?: ExclusionEntity[],
        public Poliza?: PolizaEntity,
        public NombrePlan?: string,
        public CodigoPlan?: number
    ) { }
}

export class Exclusiones {
    constructor(
        public CodigoBeneficiario?: number,
        public TipoBeneficiario?: number,
        public CodigoPlan?: number,
        public CodigoCliente?: number
    ) { }
}

export class IncluirBeneficiariosVam
{
    constructor(
    public  listaTitulares ?:InclusionEntity[],
    public  listaDependientes ?:InclusionEntity[]
    ){}
}

export class ConsultaCliente {
    constructor(
        public Unidad?: number,
        public Ciudad?: number,
        public RolEmpleado?: number,
        public Cliente?: number,
        public Grupo?: number,
        public NombreGrupo?: string,
        public NombreCliente?: string,
        public CodigoAseguradora?: number
    ) { }
}
export class BusquedaFacturacion {
    constructor(
        public CodigoGrupo?: number,
        public CodigoCiudad?: number,
        public CodigoCliente?: number,
        public CodigoUnidad?: number,
        public CodigoRamo?: string,
        public CodigoPrestacion?: number,
        public CodigoTipoNegocio?: number,
        public Anio?: number,
        public Mes?: number,
        public Validado?: boolean,
        public Aseguradora?: number,
        public Prima?: number,
        public FechaDesde?: Date,
        public FechaHasta?: Date
    ) {

    }

}
export class ObjMultiSelectPolizas {
    constructor(
        public  id?: number,
        public  name?: string,
        public  poliza?: string,
        public  FechaVIG1?: string,
        public  FechaVIG2?: string,
        public  planes ?:ObjMultiSelectPlanes[]
    ) {
    }

}
export class ObjMultiSelectPlanes {
    constructor(
        public  id?: number,
        public  name?: string,
    ) {
    }

};
export class FacturacionPrestacion {
    constructor(
        public Resumen?: Facturacion[],
        public Detalle?: Facturacion[],
        public Descripcion?: string,
        public CodigoUnidad?: number,
        public CodigoCiudad?: number,
        public Anio?: number,
        public Mes?: number,
        public CodigoCliente?: number
    ) {

    }

};
export class Facturacion {
    constructor(
        public CodigoCiudad?: number,
        public CodigoUnidad?: number,
        public CodigoGrupo?: number,
        public CodigoCliente?: number,
        public NombreCliente?: string,
        public CodigoRamo?: number,
        public CodigoPlan?: number,
        public NombrePlan?: string,
        public CodigoTitular?: number,
        public ApellidosNombresTitular?: string,
        public CedulaTitular?: string,
        public FechaNacimiento?: Date,
        public FechaMovimiento?: Date,
        public CodigoCategoria?: number,
        public NombreCategoria?: string,
        public PrimaNeta?: number,
        public NumeroInclusiones?: number,
        public NumeroExclusiones?: number,
        public PrimaNetaInclusiones?: number,
        public PrimaNetaExclusiones?: number,
        public ClienteAnterior?: string,
        public ClienteActual?: string,
        public NombreCatActual?: string,
        public NombreCatAnterior?: string,
        public Dependientes?: number,
        public NumeroTitulares?: number,
        public TipoMovimiento?: string,
        public Ramo?: string,
        public Codigocarta?: number,
        public TipoAfiliado?: string,
    ) { }

};
export class CombosFacturacion {
    constructor(
        public Ramos?: ComboBox[],
        public Prestaciones?: ComboBox[],
    ) {
    }
};
export class ConsultaFacturacion {
    constructor(
        public Ramo?: FacturacionRamo,
        public Prestacion?: FacturacionPrestacion
    ) {

    }

};
export class FacturacionRamo {
    constructor(
        public Resumen?: FacturacionResumen[],
        public TitularesSinMovimientos?: Facturacion[],
        public Movimientos?: Facturacion[],
        public TitularesIncluidos?: Facturacion[],
        public TitularesExcluidos?: Facturacion[],
        public CambioCategoria?: Facturacion[],
        public CambioEmpresa?: Facturacion[],
        public PrimaFacturada?: number,
        public Pendientes?: Facturacion[]
    ) {

    }

};
export class FacturacionResumen {
    constructor(
        public NombreCliente?: string,
        public NombrePlan?: string,
        public PrimaInclusiones?: number,
        public PrimaExclusiones?: number,
        public PrimaSinMov?: number,
        public PrimaTotal?: number,
        public Inclusiones?: number,
        public SinMovimientos?: number,
        public Exclusiones?: number,
        public NombreCategoria?: string,
        public PrimaTitularSinMov?: number,
        public PrimaDependienteSinMov?: number,
        public PrimaTitularIncl?: number,
        public PrimaDependienteIncl?: number,
        public PrimaTitularExcl?: number,
        public PrimaDependienteExcl?: number,
    ) { }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/vam_entities.ts